<template>
  <div class="goods-info">
    <div class="goods-left">
      <img
        v-lazy="
          itemGoods.skuImg && itemGoods.skuImg.url
            ? handleImg({ url: itemGoods.skuImg.url, width: 176, height: 176 })
            : ''
        "
        alt=""
      />
    </div>
    <div class="goods-right">
      <p class="goods-name">{{ itemGoods.merchandiseName }}</p>
      <div
        class="goods-sku"
        v-if="itemGoods.skuAttrs && itemGoods.skuAttrs.length"
      >
        <div class="goods-sku-left">
          <span
            v-for="(itemSku, indexSku) in itemGoods.skuAttrs"
            :key="indexSku"
          >
            {{ itemSku.attributeNameEn}}：{{
              itemSku.attributeValueEn
            }}
          </span>
        </div>
        <div class="goods-sku-right">x{{ itemGoods.buyNum }}</div>
      </div>
      <p class="goods-pay-money">
        {{ `${itemGoods.merchandiseSnapshot.priceMoney.symbol} ${$currencyFormatter(itemGoods.merchandiseSnapshot.priceMoney.number)}`
        }}
      </p>
    </div>
  </div>

</template>

<script>
export default {
    data() {
        return {
        }
    },
    props: {
        itemGoods: Object,
    },
};
</script>

<style scoped lang="less">
.goods-info {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  .goods-left {
    width: 88px;
    height: 88px;
    border-radius: 3px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .goods-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 70%;
    .goods-name {
      font-size: 13px;
      color: #161a1a;
      line-height: 20px;
      text-align: left;
    }
    .goods-sku {
      align-items: center;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #a4a4a4;
      .goods-sku-left {
        text-align: left;
        width: 85%;
        span {
          line-height: 20px;
        }
        :first-child {
          margin-right: 3px;
        }
      }
    }
    .goods-pay-money {
      font-size: 12px;
      color: #b4282d;
      text-align: right;
    }
  }
}
</style>
